import { createFileRoute, notFound } from "@tanstack/react-router";
import { CategoryPage } from "@/components/site/CategoryPage";
import { pageHead } from "@/components/site/seo-copy";
import { categoryBySlug, locationBySlug } from "@/components/site/seo";

const category = categoryBySlug("sales-jobs")!;

export const Route = createFileRoute("/sales-jobs/$location")({
  loader: ({ params }) => {
    const place = locationBySlug(params.location);
    if (!place) throw notFound();
    return { place };
  },
  head: ({ params, loaderData }) => {
    if (!loaderData) {
      return { meta: [{ title: "Sales jobs | CLOSDD" }, { name: "robots", content: "noindex" }] };
    }
    return pageHead(`/sales-jobs/${params.location}`);
  },
  component: LocationPage,
});

function LocationPage() {
  const { place } = Route.useLoaderData();
  return <CategoryPage category={category} locationName={place.name} />;
}
